import {BaseOptionsProps} from '../typings';
import {ListProps} from './typings';

export const styleOptions: BaseOptionsProps[] = [
  {
    label: 'abstract',
    value: 'abstract',
    suboptions: [
      {label: 'geometric', value: 'abstract-geometric'},
      {label: 'organic', value: 'abstract-organic'},
    ],
  },
  {
    label: 'collage',
    value: 'collage',
    filtersOnly: true,
  },
  {
    label: 'expressionistic',
    value: 'expressive-and-gestural',
  },
  {
    label: 'graphic, illustrative and typographic',
    value: 'graphic-illustrative-and-typographic',
    filtersOnly: true,
    suboptions: [
      {label: 'cartoon', value: 'graphic-illustrative-and-typographic-cartoon'},
      {label: 'graphic', value: 'graphic-illustrative-and-typographic-graphic'},
      {label: 'illustrative', value: 'graphic-illustrative-and-typographic-illustrative'},
      {label: 'typographic', value: 'graphic-illustrative-and-typographic-typographic'},
    ],
  },
  {
    label: 'impressionistic',
    value: 'impressionistic',
  },
  {
    label: 'naive',
    value: 'naive',
    filtersOnly: true,
  },
  {
    label: 'photorealistic',
    value: 'photorealistic',
  },
  {
    label: 'surrealistic',
    value: 'surrealistic',
  },
  {
    label: 'urban & pop',
    value: 'urban-and-pop',
  },
  {
    label: 'unspecified',
    value: 'unspecified',
    filtersOnly: true,
  },
];

export const styleFilterList: Readonly<ListProps> = {
  type: 'radio',
  style: 'text',
  options: [
    {
      label: 'all art',
      value: 'all',
    },
    ...styleOptions.map((category) => ({
      label: category.label,
      value: category.value,
      sublist: category.suboptions
        ? {
            type: 'radio' as const,
            style: 'button' as const,
            options: [
              {label: 'all art', value: 'all'},
              ...category.suboptions.map((suboption) => ({
                label: suboption.label,
                value: suboption.value,
              })),
            ],
          }
        : undefined,
    })),
  ],
};
